import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
// Simple utility for class merging if not already present, otherwise I'll inline it or create it.
// Since I don't have a lib/utils yet, I'll create a simple helper here or just use template literals.
// I'll create a utils file first actually, it's good practice.
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#ff2d7a] disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#ff2d7a] text-white hover:bg-[#e01b65] shadow-[0_0_15px_rgba(255,45,122,0.4)] hover:shadow-[0_0_25px_rgba(255,45,122,0.6)] border border-transparent',
    secondary: 'bg-white/10 text-white hover:bg-white/20 backdrop-blur-sm border border-white/10',
    outline: 'bg-transparent text-white border border-[#ff2d7a] hover:bg-[#ff2d7a]/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className || ''}`} {...props} data-id="element-131">
      {children}
    </motion.button>;
}